import React from 'react'

const AllDocuments = () => {
  return (
    <div>
      <ul>
         <li>
            <a
              href="https://finaltouchnew.pages.dev/"
              target="_blank"
              rel="noopener noreferrer"
              className="block py-2 px-3 text-gray-900 md:p-0 dark:text-white hover:text-blue-700 dark:hover:text-blue-500"
            >
              All documents
            </a>
          </li>
      </ul>
    </div>
  )
}

export default AllDocuments
